var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagLineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "83.207px",
    height: "122.879px",
    viewBox: "0 0 83.207 122.879",
    enableBackground: "new 0 0 83.207 122.879",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.458C0,1.1,1.101,0,2.458,0c1.357,0,2.458,1.1,2.458,2.458v4.276c17.879,4.529,27.991,1.129,37.34-2.015 C53.16,1.052,63.104-2.292,81.729,5.839c0.922,0.401,1.473,1.302,1.473,2.246h0.006V68.65c0,1.356-1.1,2.457-2.457,2.457 c-0.377,0-0.734-0.085-1.055-0.237c-15.799-7.177-26.041-3.969-36.816-0.593c-10.491,3.286-21.45,6.717-37.963,2.083v48.062 c0,1.357-1.101,2.457-2.458,2.457c-1.357,0-2.458-1.1-2.458-2.457V2.458L0,2.458z M4.916,11.775v55.468 c15.9,4.803,26.433,1.504,36.504-1.651c10.91-3.418,21.318-6.676,36.873-0.644V9.705C62.336,3.136,53.486,6.111,43.811,9.364 C34.011,12.66,23.427,16.218,4.916,11.775L4.916,11.775z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLineIcon);
export default __webpack_public_path__ + "static/media/flag-line-icon.319a0036dea39d8542d0b5d8566b6f83.svg";
export { ForwardRef as ReactComponent };